/* eslint-disable react/jsx-no-useless-fragment */
import { RouteProps, Navigate, useLocation } from 'react-router-dom';
import { paths } from 'src/paths';
import { useContext } from 'react';
import AuthContext from './AuthContext';

function PublicRoute({ children }: RouteProps): JSX.Element {
  const { redirectSupervisor } = paths;

  const location = useLocation();
  const auth = useContext(AuthContext);
  const isLoggedIn = auth.authenticated;

  const redirectToPrevious = () => {
    if (location.state && location.state.from) {
      return (
        <Navigate
          to={location.state.from}
          replace
        />
      );
    }
    return (
      <Navigate
        to={redirectSupervisor}
        replace
      />
    );
  };
  return <>{!isLoggedIn ? children : redirectToPrevious()}</>;
}

export default PublicRoute;
